import { useEffect, useRef, useCallback, useState } from 'react';
import { useStore } from '../context/StoreContext';
import { useQueryClient } from '@tanstack/react-query';

const WS_URL = process.env.REACT_APP_WS_URL ||
  (process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1')
    .replace('http', 'ws')
    .replace('/api/v1', '');

export function useStoreWebSocket() {
  const { selectedStore } = useStore();
  const qc = useQueryClient();
  const wsRef = useRef(null);
  const [connected, setConnected] = useState(false);

  const connect = useCallback(() => {
    const storeId = selectedStore?.id;
    if (!storeId) return;
    const token = localStorage.getItem('access_token');
    if (!token) return;

    const url = `${WS_URL}/ws/store/${storeId}?token=${token}`;
    const ws = new WebSocket(url);
    wsRef.current = ws;

    ws.onopen = () => setConnected(true);
    ws.onclose = () => {
      setConnected(false);
      setTimeout(connect, 5000);
    };
    ws.onerror = () => ws.close();
    ws.onmessage = (event) => {
      try {
        const msg = JSON.parse(event.data);
        if (msg.type === 'new_sale') {
          qc.invalidateQueries({ queryKey: ['sales', storeId] });
          qc.invalidateQueries({ queryKey: ['dashboard', storeId] });
        } else if (msg.type === 'inventory_update') {
          qc.invalidateQueries({ queryKey: ['products', storeId] });
        }
      } catch {}
    };

    return () => ws.close();
  }, [selectedStore?.id, qc]);

  useEffect(() => {
    const cleanup = connect();
    return () => {
      wsRef.current?.close();
      cleanup?.();
    };
  }, [connect]);

  return { connected };
}
